import { render, staticRenderFns } from "./cabinOfPossibilityMobile.vue?vue&type=template&id=6beb3a26&scoped=true&"
import script from "./cabinOfPossibilityMobile.vue?vue&type=script&lang=js&"
export * from "./cabinOfPossibilityMobile.vue?vue&type=script&lang=js&"
import style0 from "./cabinOfPossibilityMobile.vue?vue&type=style&index=0&id=6beb3a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb3a26",
  null
  
)

export default component.exports